import * as Sentry from '@sentry/react';

import { shouldInitSentry } from '@seaters/constants';

import {
  IS_DEV_SERVER,
  MODE,
  SENTRY_DEV_ENABLED,
  SENTRY_DSN,
} from '../../constants/env';

export function sentryInit() {
  if (
    !shouldInitSentry({
      isDevServer: IS_DEV_SERVER,
      devOptIn: SENTRY_DEV_ENABLED,
    })
  ) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: MODE,
    // Events land in the shared `seaters-app` project — this app has its own
    // client key, but keys do not segment issues. This tag is the only thing
    // separating invitation's errors from the admin SPA's; filter on
    // `app:invitation` in Sentry search.
    initialScope: { tags: { app: 'invitation' } },
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    ],
    // v8+ moved this to the top level; passed inside browserTracingIntegration
    // it is silently ignored, and then sentry-trace + baggage never leave the
    // browser, so the Java/Node spans look unparented in Sentry.
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api\.seaters\.com/,
      /^https:\/\/api\.qa-seaters\.com/,
    ],
    tracesSampleRate: 0.1,
    enableLogs: true,
  });
}
